<template>
<div>
  <v-card id="card">
    <v-card-text class="pa-0">
      <div class="d-flex justify-center align-center" :style="`height: ${windowHeight - 48}px;`" v-if="!loaded">
        <v-progress-circular
            size="50"
            indeterminate
            color="primary"
            v-if="!loaded"
        ></v-progress-circular>
      </div>
      <v-row style="width: 100%" v-show="loaded" class="ma-0">
        <v-col cols :style="`max-height: ${windowHeight - 48}px; overflow: scroll; background-color: #f1f4f6 !important;`">
          <div ref="print">
            <cover-page class="page"></cover-page>
            <content-table v-if="report" class="page" :naviList="naviList"
                           :naviVisibleList="naviList.filter(item => item.visible)"
                           :pdfPageNum="calculatePdfPageCount()"
                           :cropImagePageNum="cropImagePageNum"></content-table>
            <overview-page v-if="report" class="page" :report="report" :naviVisibleList="naviList.filter(item => item.visible)"
                           :pdfPageNum="calculatePdfPageCount()"
                           :cropImagePageNum="cropImagePageNum"></overview-page>
            <thermal-page v-if="report" class="page" :report="report" v-show="naviList.find(i => i.value === 'thermal-page').visible"
                          :naviVisibleList="naviList.filter(item => item.visible)"
                          :pdfPageNum="calculatePdfPageCount()"
                          @doneLoadingImage="doneLoadingImage"
                          :filter="filterReport"
                          :annotationTypes="annotationTypes"
                          :cropImagePageNum="cropImagePageNum"></thermal-page>
            <color-page v-if="report" class="page" :report="report" v-show="naviList.find(i => i.value === 'color-page').visible"
                        :naviVisibleList="naviList.filter(item => item.visible)"
                        :pdfPageNum="calculatePdfPageCount()"
                        @doneLoadingImage="doneLoadingImage"
                        :filter="filterReport"
                        :annotationTypes="annotationTypes"
                        :cropImagePageNum="cropImagePageNum"></color-page>
            <explain-page v-if="report" class="page" :naviVisibleList="naviList.filter(item => item.visible)"
                          :pdfPageNum="calculatePdfPageCount()"
                          :cropImagePageNum="cropImagePageNum"></explain-page>
            <fault-map-page v-if="report" class="page" :naviVisibleList="naviList.filter(item => item.visible)"
                            :cropImagePageNum="cropImagePageNum" :pdfPageNum="calculatePdfPageCount()"
                            :report="report"></fault-map-page>
            <drone-result-page v-if="report" class="page" :report="report"
                               :naviVisibleList="naviList.filter(item => item.visible)"
                               :pdfPageNum="calculatePdfPageCount()"

                               :cropImagePageNum="cropImagePageNum"></drone-result-page>
            <drone-result-graph-page v-if="report" class="page" :report="report"
                                     :naviVisibleList="naviList.filter(item => item.visible)"
                                     :pdfPageNum="calculatePdfPageCount()"
                                     :cropImagePageNum="cropImagePageNum"></drone-result-graph-page>
            <crop-image-page class="page" :report="report" :selectedImages="selectedImages"
                             v-for="i in cropImagePageNum" :key="i"
                             :naviVisibleList="naviList.filter(item => item.visible)"
                             :pdfPageNum="calculatePdfPageCount()"
                             :cropImagePageNum="cropImagePageNum"></crop-image-page>
            <div v-for="(itm, idx) in naviList.slice(naviList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）')+1)" :key="'pdf-item-' + idx">
              <pdf-page class="page"
                        :id="idx + '-pdf-page-' + index"
                        :naviVisibleList="naviList.filter(item => item.visible)"
                        :cropImagePageNum="cropImagePageNum"
                        :pdfPageNum="calculatePdfPageCount()"
                        :pdfNum="idx"
                        :pageOrder="index-1"
                        :title="itm.text"
                        :page="itm.pages[index-1].url"
                        :pdfId="itm.pages[index-1].id"
                        @doneLoadingPdfPage="doneLoadingPdfPage"
                        v-for="index in Number(itm.pageAmount)" :key="idx + '-pdf-page-' + index">
              </pdf-page>
            </div>
          </div>
        </v-col>
        <v-col cols="auto" :style="'min-width: 270px; max-width: 270px; position: relative; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); ' + `max-height: ${windowHeight - 48}px; overflow: scroll;`" class="d-flex flex-column elevation-0">
          <v-list>
            <v-list-item-group
                v-model="selectedPage"
                color="primary"
                mandatory
            >
              <v-list-item v-for="(value, index) in naviList.filter(s => s.visible)" :key="'v-list-item-'+index" :value="value.value">
                <template v-slot:default>
                  <v-list-item-content :class="value.visible ? '' : 'grey--text'" class="py-0">
                    <v-list-item-title class="d-flex">
                      <span>{{ index > 1 ? index - 1 + '.' : '※' }} {{ value.text }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <div class="align-self-center align-end">
            <v-btn @click="downloadReport" color="primary" block :disabled="!downloadable">印刷・PDFに保存</v-btn>
          </div>
          <div class="align-self-center align-end pt-4">
            <a :href="'/map/' + folderUuid">マップへ</a>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</div>
</template>

<script>
import {store} from "@/store";
import ThermalPage from "@/components/report/ThermalPage";
import ColorPage from "@/components/report/ColorPage";
import ExplainPage from "@/components/report/ExplainPage";
import FaultMapPage from "@/components/report/FaultMapPage";
import DroneResultPage from "@/components/report/DroneResultPage";
import CropImagePage from "@/components/report/CropImagePage";
import DroneResultGraphPage from "@/components/report/DroneResultGraphPage";
import CoverPage from "@/components/report/CoverPage";
import ContentTable from "@/components/report/ContentTable";
import OverviewPage from "@/components/report/OverviewPage";
import PdfPage from "@/components/report/PdfPage";
// import html2pdf from "html2pdf.js/src";
// import { jsPDF } from "jspdf";

export default {
  name: "Report",
  components: {
    PdfPage,
    'cover-page': CoverPage,
    'content-table': ContentTable,
    'overview-page': OverviewPage,
    'thermal-page': ThermalPage,
    'color-page': ColorPage,
    'explain-page': ExplainPage,
    'fault-map-page': FaultMapPage,
    'drone-result-page': DroneResultPage,
    'drone-result-graph-page': DroneResultGraphPage,
    'crop-image-page': CropImagePage,
  },
  data(){
    return {
      reportName: null,
      selectedPage: 'cover-page',
      windowHeight: window.innerHeight,
      report: null,
      folderUuid: this.$route.params.folderUuid,
      listCropImage: [],
      selectedImages: [],
      cropImagePageNum: 1,
      naviList: [
        {
          text: '表紙',
          visible: true,
          isNew: false,
          value: 'cover-page'
        },
        {
          text: '目次',
          visible: true,
          isNew: false,
          value: 'content-table'
        },
        {
          text: '概要',
          visible: true,
          isNew: false,
          value: 'overview-page'
        },
        {
          text: 'サーマルオルソ画像',
          visible: false,
          isNew: false,
          value: 'thermal-page'
        },
        {
          text: 'RGBオルソ画像',
          visible: false,
          isNew: false,
          value: 'color-page'
        },
        {
          text: '故障モード解説',
          visible: true,
          isNew: false,
          value: 'explain-page'
        },
        {
          text: 'ドローン検査結果',
          visible: true,
          isNew: false,
          value: 'drone-result-page'
        },
        {
          text: 'ドローン検査詳細（抜粋）',
          visible: true,
          isNew: false,
          value: 'crop-image-page'
        }
      ],
      loaded: false,
      errorType: {
        'cell': 'ホットスポット',
        'multicell': 'マルチホットスポット',
        'cluster': 'クラスタバイパス',
        'module': 'モジュール異常',
        'string': 'ストリング異常',
        'junction': 'ジャンクションボックス過熱',
        'pid': 'ＰＩＤ現象の疑い',
        'shadow': '影',
      },
      errorReason: {
        "crack": "割れ",
        "sediment": "堆積物",
        "vegetation": "植生"
      },
      loadingThermalImage: true,
      loadingColorImage: true,
      filterReport: [],
      annotationTypes: {
        'cell': false,
        'multicell': false,
        'cluster': false,
        'module': false,
        'string': false,
        'junction': false,
        'pid': false,
        'shadow': false
      },
      sharedState: store.state,
    }
  },

  methods: {
    calculatePdfPageCount(){
      let num = 0;
      const list = this.naviList.slice(this.naviList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）')+1)
      list.forEach(item => {
        num += Number(item.pageAmount)-1;
      });
      return num;
    },
    doneLoadingImage(color){
      if (color === 'color'){
        this.loadingColorImage = false;
      }
      else {
        this.loadingThermalImage = false;
      }
    },
    getReport() {
      this.listCropImage = [];
      this.selectedImages = [];
      this.report = null;
      this.axios
          .get('/api/report/' + this.folderUuid)
          .then((response) => {
            this.report = response.data.report;
            response.data.annotation.panel_abnormality.list.forEach(item => {
              this.annotationTypes[item.type] = true;
            });

            if (this.report.page_visible.includes('thermal')){
              const thermal = this.naviList.find(i => i.value === 'thermal-page');
              thermal.visible = true;
            }
            if (this.report.page_visible.includes('color')){
              const color = this.naviList.find(i => i.value === 'color-page');
              color.visible = true;
            }

            store.updateReportBreadcrumbs([
              {
                text: "ダッシュボード",
                disabled: false,
                exact: true,
                to: "/dashboard"
              },
              {
                text: this.report.plant_name,
                disabled: false,
                exact: true,
                to: "/site/" + this.report.uuid
              },
              {
                text: 'レポート',
                disabled: false,
                exact: true,
                to: "/report/" + this.report.folder.uuid
              },
              {
                text: this.report.shooting_date,
                disabled: false,
                exact: true,
                to: "/report/" + this.report.folder.uuid
              },
            ]);

            this.filterReport = this.report.filter.panel_error_types;
            this.updateReportName();
            const list = this.report.annotation_image.list;
            for (const [key, value] of Object.entries(list)) {
              for (const [k, v] of Object.entries(value.crop_shape_list)) {
                const image = {
                  src: v.image,
                  filename: key,
                  crop_image_id: k,
                  selected: v.selected,
                  errorType: v.errorType,
                  errorNote: v.errorNote,
                  errorReason: v.errorReason,
                  index: v.index
                };
                this.listCropImage.push(image);
                if (v.selected){
                  this.selectedImages.push(image);
                }
              }
            }
            this.selectedImages.sort((a, b) => {
              return a.index - b.index;
            });
            let last = 0;
            const tempSelectedImages = JSON.parse(JSON.stringify(this.selectedImages));
            tempSelectedImages.forEach((item, index) => {
              if (index > 0){
                for (let i = 0; i < item.index - tempSelectedImages[index-1].index - 1; i++){
                  this.selectedImages.splice(last + i, 0, {src: null});
                }
              }
              last = item.index + 1;
            })
            // this.calculateCropImagePageNum();
            this.loaded = true;
            Object.values(response.data.report_pdf_pages).forEach((val) => {
              const pages = [];
              Object.values(val).forEach(page => {
                pages.push(page);
              });

              this.naviList.push({
                text: pages[0].name,
                visible: true,
                isPdf: false,
                index: this.naviList.length,
                pageAmount: pages.length,
                pages: pages,
                loading: true,
                isNew: false
              });
            })
          })
          .catch(() => {
            store.showErrorDialog('エラーが発生しました。再度試してください。');
          });
    },
    updateReportName(){
      if (this.report){
        this.reportName = this.report.plant_name + '_' + this.report.shooting_date;
      }
    },
    onResize(){
      this.windowHeight = window.innerHeight;
    },
    printReport() {
      const WinPrint = window.open('/report/download', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.onload = () => {
        WinPrint.document.title = this.reportName;
        WinPrint.focus();
        // WinPrint.document.getElementsByTagName('header')[0].remove();
        WinPrint.document.getElementsByClassName('v-main')[0].style.padding = '0';
        WinPrint.document.getElementById('temp').outerHTML = JSON.parse(JSON.stringify(this.$refs.print.outerHTML));
        WinPrint.document.getElementById('cover-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('content-table').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('overview-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('thermal-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('color-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('explain-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('fault-map-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('drone-result-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('drone-result-graph-page').classList.replace('page', 'page_print');
        WinPrint.document.getElementById('crop-image-page').classList.replace('page', 'page_print');
        const list = WinPrint.document.getElementsByClassName('crop-image-page');
        for (let i = 0; i < list.length; i++) {
          list[i].classList.remove('page');
          list[i].classList.add('page_print');
        }
        const naviList = this.naviList.slice(this.naviList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）')+1);
        naviList.forEach((item, idx) => {
          for (let index = 1; index <= Number(item.pageAmount); index++) {
            WinPrint.document.getElementById(`${idx}-pdf-page-${index}`).classList.replace('page', 'page_print');
          }
        })
        WinPrint.onafterprint = () => {
          setTimeout(() => {WinPrint.close();}, 100);
        }
        let incrementCounter;
        incrementCounter = () => {
          counter++;
          if (counter === len){
            setTimeout(() => {
              WinPrint.print();
              // html2pdf().from(WinPrint.document.body).set({pagebreak: {mode: 'avoid-all', before: '.page_print'}, html2canvas: {useCORS: true}}).save(this.reportName);
            }, 100);
          }
        }
        let imgs = WinPrint.document.images, len = imgs.length, counter = 0;
        if (imgs.length > 0){
          Array.from(imgs).forEach((img) => {
            if (img.complete){
              incrementCounter();
            }
            else {
              img.addEventListener('load', incrementCounter, false);
            }
          })
        }
        else {
          setTimeout(() => {
            WinPrint.print();
            // html2pdf().from(WinPrint.document.body).set({pagebreak: {mode: 'avoid-all'}, html2canvas: {useCORS: true}}).save(this.reportName);
          }, 100);
        }
      }


    },
    downloadReport(){
      const img = require('@/assets/images/download_settings.png')
      const confirmDialog = {
        title: 'レポートダウンロード',
        content: '次のダイアログの送信先を「印刷」か「PDFに保存」と設定ください。<img src="' + img + '">',
        onAgree: () => {
          this.printReport();
        }
      };
      store.showConfirmDialog(confirmDialog);
    },
    doneLoadingPdfPage(pdfId){
      const naviList = this.naviList.filter(i => ('isPdf' in i)).find(i => i.pages.find(v => v.id === pdfId));
      if (naviList){
        if (naviList.loading){
          naviList.loading = false;
        }
      }
    }
  },

  computed: {
    downloadable(){
      return this.naviList.filter(i => ('isPdf' in i)).every(i => !i.loading) && !(this.loadingThermalImage || this.loadingColorImage);
    }
  },

  created() {
    this.getReport();
  },

  watch: {
    selectedPage(selectedPage) {
      if (typeof selectedPage == 'string'){
        document.getElementById(selectedPage).scrollIntoView({behavior: 'smooth'});
      }
      else {
        document.getElementById(`${selectedPage - this.naviList.filter(i => i.visible).findIndex(item => item.text === 'ドローン検査詳細（抜粋）') -1}-pdf-page-1`).scrollIntoView({behavior: 'smooth'});
      }
    },
  },

  mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style scoped>
*{
  -webkit-print-color-adjust: exact;
}
.page {
  margin: 0px auto 50px;
  height: 297mm;
  width: 210mm;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: white;
}
@page {
  size: A4;
  margin: 0;
}
.page_print{
  margin: auto;
  height: 295mm;
  width: 210mm;
}
@media print {
  body, html, #card {
    height: 100%;
  }
  .page_print{
    page-break-inside: avoid;
  }
}
</style>
